import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const MyCkEditor = ({ bodyText, setBodyText }) => (
	<CKEditor
		editor={ClassicEditor}
		data={bodyText}
		onChange={(event, editor) => {
			const data = editor.getData();
			console.log({ event, editor, data });
			setBodyText(data);
		}}
		config={{
			placeholder: 'Write your email here...',
			toolbar: ['heading', '|', 'bold', 'italic', 'undo', 'redo'],
		}}
	/>
);

export default MyCkEditor;
